import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  SUI_DIALOG_SIMPLE_SLOTS,
  SUI_DIALOG_TABS_SLOTS,
  SuiDialogSimpleComponent,
  SuiDialogTabsComponent,
} from '@sui/dialog';
import { SuiInputComponent } from '@sui/input';
import { SuiTextareaComponent } from '@sui/textarea';
import { SuiSwitchComponent } from '@sui/switch';
import { SuiCheckboxComponent } from '@sui/checkbox';
import { SuiButtonComponent } from '@sui/button';
import { SuiButtonGroupComponent } from '@sui/button-group';
import { SuiRadioComponent, SuiRadioGroupDirective } from '@sui/radio';
import { SuiSelectComponent, SuiSelectOptionComponent } from '@sui/select';
import { SuiComboboxComponent } from '@sui/combobox';
import { SuiProgressComponent } from '@sui/progress';
import { SuiToolbarComponent } from '@sui/toolbar';
import {
  SuiHintDirective,
  SuiLabelDirective,
  SuiErrorDirective,
  SuiFormFieldComponent,
} from '@sui/form-field';

import { AdvancedSearchComponent } from '../admin/components/advanced-search/advanced-search.component';
import { AgGridModule } from 'ag-grid-angular';
import { AlertCardComponent } from './components/cards/alert-card/alert-card.component';
import { AlgorithmListCardComponent } from './components/cards/algorithm-list-card/algorithm-list-card.component';
import { AlgorithmPickerComponent } from './components/panels/feed-algorithms/algorithm-picker/algorithm-picker.component';
import { AlertEditorComponent } from './components/alert-editor/alert-editor.component';
import { AlertEditorDialogComponent } from './components/popups/alert-editor-dialog/alert-editor-dialog.component';
import { AlertsCenterComponent } from './containers/alerts-center/alerts-center.component';
import { AlertsComponent } from './containers/alerts/alerts.component';
import { AlghorithmDialogComponent } from './components/popups/alghorithm-dialog/alghorithm-dialog.component';
import { AlgorithmScheduleComponent } from './components/algorithm-schedule/algorithm-schedule.component';
import { AnalyticsComponent } from './containers/analytics/analytics.component';
import { AuditTrailComponent } from './components/audit-trail/audit-trail.component';
import { AuthentificationGuard } from './authetification.guard';
import { AuthentificationResolver } from './authetification.resolver';
import { AutoStoryRunsComponent } from './containers/auto-story-runs/auto-story-runs.component';
import { AutocompleteModule } from './components/autocomplete/autocomplete.module';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CategoryComponent } from './components/popups/post-user-categories/category/category.component';
import { ChangePasswordDialogComponent } from './components/popups/change-password-dialog/change-password-dialog.component';
import { ColorPickerModule } from '@iplab/ngx-color-picker';
import { CommonModule } from '@angular/common';
import { CoreRoutingModule } from './core-routing.module';
import { DashboardComponent } from './containers/dashboard/dashboard.component';
import { DashboardDuplicateDialogComponent } from './components/popups/dashboard-duplicate-dialog/dashboard-duplicate-dialog.component';
import { DashboardDuplicateFormComponent } from './components/popups/dashboard-duplicate-dialog/dashboard-duplicate-form/dashboard-duplicate-form.component';
import { DashboardEditorDialogComponent } from './components/popups/dashboard-settings/dashboard-editor-dialog/dashboard-editor-dialog.component';
import { DashboardPageComponent } from './containers/dashboard/dashboard-page.component';
import { DashboardPresentationModeComponent } from './components/dashboard-presentation-mode/dashboard-presentation-mode.component';
import { DashboardPresentationSettingsComponent } from './components/dashboard-presentation-settings/dashboard-presentation-settings.component';
import { DashboardSettingsComponent } from './components/popups/dashboard-settings/dashboard-settings.component';
import { DashboardsComponent } from './containers/dashboards/dashboards.component';
import { DataObjectListComponent } from './components/dataobject-list/dataobject-list.component';
import { DimensionsComponent } from './containers/dimensions/dimensions.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DropdownAlertsComponent } from './components/dropdowns/dropdown-alerts/dropdown-alerts.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { DropdownNotificationsComponent } from './components/dropdowns/dropdown-notifications/dropdown-notifications.component';
import { DropdownSchedulesComponent } from './components/dropdowns/dropdown-schedules/dropdown-schedules.component';
import { DropdownUserComponent } from './components/dropdowns/dropdown-user/dropdown-user.component';
import { DynamicFormComponent } from '../shared/components/dynamic-form/dynamic-form.component';
import { EditorUserDialog } from './components/popups/editor-user-dialog/editor-user-dialog';
import { ExportSchedulesComponent } from './containers/export-schedules/export-schedules.component';
import { ExportSettingsComponent } from './components/panels/export-settings/export-settings.component';
import { ExportStatusComponent } from './components/popups/export-status/export-status.component';
import { FeedAlertsComponent } from './components/panels/feed-alerts/feed-alerts.component';
import { FeedAlgorithmsComponent } from './components/panels/feed-algorithms/feed-algorithms.component';
import { FeedComponent } from './containers/feed/feed.component';
import { FeedResultsPreviewDialogComponent } from './components/popups/feed-results-preview-dialog/feed-results-preview-dialog.component';
import { FeedCreateWizardDialogComponent } from './components/popups/feed-create-wizard-dialog/feed-create-wizard-dialog.component';
import { FeedDuplicateDialogComponent } from './components/popups/feed-duplicate-dialog/feed-duplicate-dialog.component';
import { FeedDuplicateFormComponent } from './components/popups/feed-duplicate-dialog/feed-duplicate-form/feed-duplicate-form.component';
import { FeedLevelLayoutAndFormatComponent } from './components/popups/output-settings/feed-level-layout-and-format/feed-level-layout-and-format.component';
import { FeedOperatorListComponent } from './components/popups/query-editor/popup/query-editor-popup/feed-operator-list/feed-operator-list.component';
import { FeedQueryEditorComponent } from './components/panels/feed-query-editor/feed-query-editor.component';
import { FeedQueryHintsPopupComponent } from './components/popups/feed-query-hints-popup/feed-query-hints-popup.component';
import { FeedViewsComponent } from './components/feed-views/feed-views.component';
import { FeedsComponent } from './containers/feeds/feeds.component';
import { FiltersComponent } from './components/panels/filters/filters.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GalleryViewerComponent } from './components/gallery-viewer/gallery-viewer.component';
import { GeneralDynamicFormComponent } from './components/general-dynamic-form/general-dynamic-form.component';
import { GridstackModule } from 'gridstack/dist/angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderComponent } from './components/header/header.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { HomeComponent } from './containers/home/home.component';
import { ImportUsersDialogComponent } from './components/popups/import-users-dialog/import-users-dialog.component';
import { InViewDirective } from './directives/in-view.directive';
import { LanguagePickerComponent } from './components/language-picker/language-picker.component';
import { LazyLoadBackgroundDirective } from './directives/lazy-load-background.directive';
import { LazyLoadDirective } from './directives/lazy-load.directive';
import { LoadingCardComponent } from './components/loading-card/loading-card.component';
import { MainMenuComponent } from './components/main-menu/main-menu.component';
import { MatIconModule } from '@angular/material/icon';
import { ModuleSwitchComponent } from './components/module-switch/module-switch.component';
import { MoveObjectDialogComponent } from './components/popups/move-object-dialog/move-object-dialog.component';
import { NgModule } from '@angular/core';
import { NgToastComponent } from 'ng-angular-popup';
import { NotificationComponent } from './components/notification/notification.component';
import { NotificationsComponent } from './containers/notifications/notifications.component';
import { ObjectCardComponent } from './components/cards/object-card/object-card.component';
import { ObjectCardDropdownComponent } from './components/cards/object-card/object-card-dropdown/object-card-dropdown.component';
import { ObjectCardPlaceholderComponent } from './components/cards/object-card-placeholder/object-card-placeholder.component';
import { WidgetToolbarComponent } from './components/widget-toolbar/widget-toolbar.component';
import { FeedResultsToolbarComponent } from './components/feed-results-toolbar/feed-results-toolbar.component';
import { ObjectPermissionsAdvancedComponent } from './components/object-permissions-advanced/object-permissions-advanced.component';
import { ObjectPermissionsComponent } from './components/object-permissions/object-permissions.component';
import { ObjectPermissionsDialogComponent } from './components/popups/object-permissions-dialog/object-permissions-dialog.component';
import { ObjectPermissionsSimpleComponent } from './components/object-permissions-simple/object-permissions-simple.component';
import { OutputLogsComponent } from './components/panels/output-logs/output-logs.component';
import { PaneInfoComponent } from './components/panels/pane-info/pane-info.component';
import { OutputSettingsComponent } from './components/popups/output-settings/output-settings.component';
import { OutputSettingsFormatEditorComponent } from './components/popups/output-settings/output-settings-format-editor/output-settings-format-editor.component';
import { OutputSettingsGeneralComponent } from './components/popups/output-settings/output-settings-general/output-settings-general.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { PageNavigatorForDashboardComponent } from './components/page-navigator-for-dashboard/page-navigator-for-dashboard.component';
import { PanelToolbarComponent } from './components/panel-toolbar/panel-toolbar.component';
import { PortalModule } from '@angular/cdk/portal';
import { PostCardComponent } from './components/cards/post-card/post-card.component';
import { PostCardDetailsComponent } from './components/cards/post-card-details/post-card-details.component';
import { StoryCardDetailsComponent } from './components/cards/story-card-details/story-card-details.component';
import { StoryPostsComponent } from './components/cards/story-card-details/story-posts/story-posts.component';
import { StoryRunParamsComponent } from './components/cards/story-card-details/story-run-params/story-run-params.component';
import { PostCardsToolsComponent } from './components/post-cards-tools/post-cards-tools.component';
import { PostListComponent } from './components/post-list/post-list.component';
import { PostCategoryTreeComponent } from './components/post/post-category-tree/post-category-tree.component';
import { PostFaceTagComponent } from './components/post/post-face-tag/post-face-tag.component';
import { PostFullContentComponent } from './components/post/post-full-content/post-full-content.component';
import { PostImageTaggingComponent } from './components/post/post-image-tagging/post-image-tagging.component';
import { PostQuickStoryComponent } from './components/post/post-quick-story/post-quick-story.component';
import { PostRelatedDialogComponent } from './components/popups/post-related-dialog/post-related-dialog.component';
import { PostScreenCaptureComponent } from './components/post/post-screen-capture/post-screen-capture.component';
import { PostSentimentDialogComponent } from './components/popups/post-sentiment-dialog/post-sentiment-dialog.component';
import { PostSourceInfoComponent } from './components/post/post-source-info/post-source-info.component';
import { PostSynopsisComponent } from './components/post/post-synopsis/post-synopsis.component';
import { PostTranslationComponent } from './components/post/post-translation/post-translation.component';
import { PostUserCategoriesDialogComponent } from './components/popups/post-user-categories-dialog/post-user-categories-dialog.component';
import { PostUserCategoriesListComponent } from './components/popups/post-user-categories/post-user-categories-list/post-user-categories-list.component';
import { PostVideoComponent } from './components/post/post-video/post-video.component';
import { PrincipalObjectListComponent } from './components/principal-object-list/principal-object-list.component';
import { QueryEditorComponent } from './components/query-editor/query-editor.component';
import { QueryEditorDialogComponent } from './components/popups/query-editor/query-editor-dialog/query-editor-dialog.component';
import { QueryEditorGeneralSettingsComponent } from './components/popups/query-editor/query-editor-general-settings/query-editor-general-settings.component';
import { QueryHistoryViewerComponent } from './components/popups/query-editor/popup/query-editor-popup/query-history-viewer/query-history-viewer.component';
import { QueryUsedByComponent } from './components/popups/query-editor/query-used-by/query-used-by.component';
import { RemoteLoginComponent } from './components/remote-login/remote-login.component';
import { RemovedItemsComponent } from './components/panels/removed-items/removed-items.component';
import { RouterModule } from '@angular/router';
import { ScheduleCardComponent } from './components/cards/schedule-card/schedule-card.component';
import { SchedulesComponent } from './components/panels/schedules/schedules.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SearchBuilderComponent } from './components/search-builder/search-builder.component';
import { SearchBuilderWrapperComponent } from './components/search-builder-wrapper/search-builder-wrapper.component';
import { SearchSuggestComponent } from './components/search-suggest/search-suggest.component';
import { SensikaAgGridModule } from '../ag-grid/ag-grid.module';
import { SensikaHttpInterceptor } from './http.interceptor';
import { ShareDialog } from './components/popups/share-dialog/share-dialog';
import { SharedModule } from '../shared/shared.module';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidebarPanelComponent } from './components/sidebar-panel/sidebar-panel.component';
import { SortableListDirective } from './directives/sortable-list.directive';
import { TagInputModule } from 'ngx-chips';
import { TimeAgoDirective } from './directives/time-ago.directive';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import { UnsavedChangesDialogComponent } from './components/popups/unsaved-changes-dialog/unsaved-changes-dialog.component';
import { UserBackgroundTaskListComponent } from './components/user-background-task-list/user-background-task-list.component';
import { UserPermissionsComponent } from './components/popups/user-edit/user-permissions/user-permissions.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { VjsPlayerComponent } from './components/vjs-player/vjs-player.component';
import { WalkthroughComponent } from './components/walkthrough/walkthrough.component';
import { WelcomeScreenComponent } from './components/welcome-screen/welcome-screen.component';
import { WidgetCardComponent } from './components/cards/widget-card/widget-card.component';
import { WidgetCardListComponent } from './components/cards/widget-card-list/widget-card-list.component';
import { WidgetPresetCardComponent } from './components/cards/widget-preset-card/widget-preset-card.component';
import { WidgetPresetGalleryComponent } from './components/popups/picker-widgets/widget-preset-gallery/widget-preset-gallery.component';
import { SwapWidgetDialogComponent } from './components/popups/swap-widget-dialog/swap-widget-dialog.component';
import { WidgetPreviewPopupComponent } from './components/popups/widget-preview-popup/widget-preview-popup.component';
import { WidgetSettingsChartAxesComponent } from './components/popups/widget-settings/widget-settings-chart-axes/widget-settings-chart-axes.component';
import { WidgetSettingsChartLayoutComponent } from './components/popups/widget-settings/widget-settings-chart-layout/widget-settings-chart-layout.component';
import { WidgetSettingsDataSeriesComponent } from './components/popups/widget-settings/widget-settings-data-series/widget-settings-data-series.component';
import { WidgetSettingsDebugChartConfigComponent } from './components/popups/widget-settings/widget-settings-debug-chart-config/widget-settings-debug-chart-config.component';
import { WidgetSettingsDebugChartJsonComponent } from './components/popups/widget-settings/widget-settings-debug-chart-json/widget-settings-debug-chart-json.component';
import { WidgetSettingsDialogComponent } from './components/popups/widget-settings/dialog/widget-settings-dialog/widget-settings-dialog.component';
import { WidgetSettingsGeneralComponent } from './components/popups/widget-settings/widget-settings-general/widget-settings-general.component';
import { WidgetSettingsOutputSettingsComponent } from './components/popups/widget-settings/widget-settings-output-settings/widget-settings-output-settings.component';
import { WidgetSidebarComponent } from './components/panels/widget-sidebar/widget-sidebar.component';
import { WidgetVisualizationTypeCardComponent } from './components/cards/widget-visualization-type-card/widget-visualization-type-card.component';
import { WizardStepsComponent } from './components/wizard-steps/wizard-steps.component';
import { WorkspaceComponent } from './containers/workspace/workspace/workspace.component';
import { WorkspaceDuplicateDialogComponent } from './components/popups/workspace-duplicate-dialog/workspace-duplicate-dialog.component';
import { WorkspaceDuplicateFormComponent } from './components/popups/workspace-duplicate-popup/workspace-duplicate-form/workspace-duplicate-form.component';
import { WorkspaceEditorDialogComponent } from './components/popups/workspace-settings/workspace-editor-dialog/workspace-editor-dialog.component';
import { WorkspaceSettingsComponent } from './components/popups/workspace-settings/workspace-settings.component';
import { YoutubePlayerComponent } from './components/youtube-player/youtube-player.component';
import { NoResultsComponent } from './components/no-results/no-results.component';
import { HelpModule } from '@help/help.module';
import { WidgetSettingsContentViewPropertiesComponent } from './components/popups/widget-settings/widget-settings-content-view-properties/widget-settings-content-view-properties.component';
import { ConfirmDialogComponent } from './components/popups/confirm-dialog/confirm-dialog.component';
import { FeedTypeSelectorComponent } from './components/popups/feed-type-selector/feed-type-selector.component';
import { BusinessConstraintsInfoDialogComponent } from './components/popups/business-constraints-info-dialog/business-constraints-info-dialog.component';
import { UseCaseWizardDialogComponent } from './components/popups/use-case-wizard-dialog/use-case-wizard-dialog.component';
import { UseCaseTemplateSelectorComponent } from './components/popups/use-case-wizard-dialog/steps/use-case-template-selector/use-case-template-selector.component';
import { UseCaseInputsStepComponent } from './components/popups/use-case-wizard-dialog/steps/use-case-inputs-step/use-case-inputs-step.component';
import { UseCasePreviewStepComponent } from './components/popups/use-case-wizard-dialog/steps/use-case-preview-step/use-case-preview-step.component';
import { UseCaseItemListComponent } from './components/popups/use-case-wizard-dialog/steps/use-case-item-list/use-case-item-list.component';
import { UseCaseSourcePickerComponent } from './components/popups/use-case-wizard-dialog/steps/use-case-source-picker/use-case-source-picker.component';
import { BusinessConstraintsInfoComponent } from './components/popups/business-constraints-info-dialog/business-constraints-info/business-constraints-info.component';
import { PickerDataobjectsDialogComponent } from './components/popups/picker-dataobjects-dialog/picker-dataobjects-dialog.component';
import { JsonViewerDialogComponent } from './components/popups/json-viewer-dialog/json-viewer-dialog.component';
import { JsonTreeComponent } from './components/popups/json-viewer-dialog/json-tree/json-tree.component';
import { InvitationLinkDialogComponent } from './components/popups/invitation-link-dialog/invitation-link-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    SortableListDirective,
    OverlayModule,
    FontAwesomeModule,
    FormsModule,
    HighchartsChartModule,
    MatIconModule,
    NgToastComponent,
    ReactiveFormsModule,
    RouterModule,
    ScrollingModule,
    TagInputModule,
    CoreRoutingModule,
    TranslateModule.forChild(),
    SharedModule,
    AgGridModule,
    SensikaAgGridModule,
    ToastrModule.forRoot(),
    PortalModule,
    GridstackModule,
    AutocompleteModule,
    ColorPickerModule,
    HelpModule,

    SuiDialogTabsComponent,
    SuiDialogSimpleComponent,
    ...SUI_DIALOG_TABS_SLOTS,
    ...SUI_DIALOG_SIMPLE_SLOTS,

    AlgorithmScheduleComponent,
    SuiInputComponent,
    SuiTextareaComponent,
    SuiSwitchComponent,
    SuiRadioComponent,
    SuiCheckboxComponent,
    SuiButtonComponent,
    SuiButtonGroupComponent,
    SuiFormFieldComponent,
    SuiSelectComponent,
    SuiSelectOptionComponent,
    SuiComboboxComponent,
    SuiProgressComponent,
    SuiToolbarComponent,
    SuiLabelDirective,
    SuiHintDirective,
    SuiErrorDirective,
    SuiRadioGroupDirective,
  ],
  declarations: [
    BreadcrumbComponent,
    DashboardComponent,
    DashboardPageComponent,
    DataObjectListComponent,

    FeedAlertsComponent,
    FeedAlgorithmsComponent,
    AlgorithmListCardComponent,
    AlgorithmPickerComponent,
    FeedsComponent,
    DashboardsComponent,
    FeedComponent,
    FeedQueryEditorComponent,
    FiltersComponent,

    HomeComponent,
    InViewDirective,

    LazyLoadBackgroundDirective,
    LazyLoadDirective,
    ObjectCardComponent,
    WidgetToolbarComponent,
    FeedResultsToolbarComponent,
    PostCardComponent,
    PostCardsToolsComponent,
    PostListComponent,
    PaneInfoComponent,
    SidebarComponent,
    SidebarPanelComponent,
    TimeAgoDirective,
    WidgetCardComponent,
    WidgetCardListComponent,
    WidgetPresetCardComponent,
    WidgetPresetGalleryComponent,
    SwapWidgetDialogComponent,
    WidgetSettingsChartAxesComponent,
    WidgetSettingsChartLayoutComponent,
    WidgetSettingsDataSeriesComponent,
    WidgetSettingsDebugChartConfigComponent,
    WidgetSettingsDebugChartJsonComponent,
    WidgetSettingsGeneralComponent,
    WidgetSettingsOutputSettingsComponent,
    WidgetVisualizationTypeCardComponent,
    WorkspaceComponent,
    SearchBuilderComponent,
    QueryEditorGeneralSettingsComponent,
    GeneralDynamicFormComponent,
    ExportStatusComponent,
    AlertCardComponent,
    AlertEditorComponent,
    PostUserCategoriesListComponent,
    CategoryComponent,
    QueryEditorComponent,
    PostCardDetailsComponent,
    StoryCardDetailsComponent,
    StoryPostsComponent,
    StoryRunParamsComponent,
    PostFullContentComponent,
    PostSynopsisComponent,
    PostTranslationComponent,
    PostQuickStoryComponent,
    PostFaceTagComponent,
    PostSourceInfoComponent,
    PostScreenCaptureComponent,
    SearchSuggestComponent,
    UserBackgroundTaskListComponent,
    WizardStepsComponent,
    FeedTypeSelectorComponent,
    UseCaseWizardDialogComponent,
    UseCaseTemplateSelectorComponent,
    UseCaseInputsStepComponent,
    UseCasePreviewStepComponent,
    UseCaseItemListComponent,
    UseCaseSourcePickerComponent,
    WorkspaceSettingsComponent,
    OutputSettingsComponent,
    OutputSettingsGeneralComponent,
    FeedLevelLayoutAndFormatComponent,
    OutputSettingsFormatEditorComponent,
    ObjectPermissionsSimpleComponent,

    SchedulesComponent,

    ObjectCardDropdownComponent,
    DashboardSettingsComponent,
    MainMenuComponent,
    HeaderComponent,
    DropdownComponent,
    DropdownAlertsComponent,
    DropdownNotificationsComponent,
    DropdownUserComponent,
    DropdownSchedulesComponent,
    FeedDuplicateFormComponent,
    QueryHistoryViewerComponent,
    FeedOperatorListComponent,
    LanguagePickerComponent,

    UserPermissionsComponent,

    PostImageTaggingComponent,

    WidgetSidebarComponent,
    FeedViewsComponent,
    SearchBuilderWrapperComponent,

    VjsPlayerComponent,
    PostVideoComponent,

    WelcomeScreenComponent,
    GalleryViewerComponent,
    VideoPlayerComponent,
    YoutubePlayerComponent,
    PostCategoryTreeComponent,
    ObjectCardPlaceholderComponent,
    ExportSettingsComponent,

    PanelToolbarComponent,
    PrincipalObjectListComponent,
    WalkthroughComponent,
    AlertsComponent,
    ExportSchedulesComponent,
    AutoStoryRunsComponent,
    DimensionsComponent,
    RemoteLoginComponent,
    RemovedItemsComponent,
    ObjectPermissionsAdvancedComponent,
    ModuleSwitchComponent,
    UserProfileComponent,
    AnalyticsComponent,
    OutputLogsComponent,
    LoadingCardComponent,
    NotificationComponent,
    NotificationsComponent,
    FeedQueryHintsPopupComponent,
    ScheduleCardComponent,
    WidgetPreviewPopupComponent,
    PageNavigatorForDashboardComponent,
    DashboardPresentationSettingsComponent,
    DashboardPresentationModeComponent,
    AdvancedSearchComponent,
    AuditTrailComponent,
    ObjectPermissionsComponent,
    AlertsCenterComponent,
    FeedLevelLayoutAndFormatComponent,
    WorkspaceDuplicateFormComponent,
    QueryUsedByComponent,
    WorkspaceEditorDialogComponent,
    DashboardEditorDialogComponent,
    WidgetSettingsDialogComponent,
    UnsavedChangesDialogComponent,
    ShareDialog,
    EditorUserDialog,
    AlertEditorDialogComponent,
    ChangePasswordDialogComponent,
    AlghorithmDialogComponent,
    FeedCreateWizardDialogComponent,
    FeedDuplicateDialogComponent,
    FeedResultsPreviewDialogComponent,
    ImportUsersDialogComponent,
    MoveObjectDialogComponent,
    ObjectPermissionsDialogComponent,
    PostRelatedDialogComponent,
    PostSentimentDialogComponent,
    PostUserCategoriesDialogComponent,
    WorkspaceDuplicateDialogComponent,
    QueryEditorDialogComponent,
    DashboardDuplicateDialogComponent,
    DashboardDuplicateFormComponent,
    NoResultsComponent,
    WidgetSettingsContentViewPropertiesComponent,
    ConfirmDialogComponent,
    BusinessConstraintsInfoDialogComponent,
    BusinessConstraintsInfoComponent,
    PickerDataobjectsDialogComponent,
    JsonViewerDialogComponent,
    JsonTreeComponent,
    InvitationLinkDialogComponent,
  ],

  providers: [
    AuthentificationResolver,
    AuthentificationGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SensikaHttpInterceptor,
      multi: true,
    },
  ],
  exports: [
    BreadcrumbComponent,
    DashboardComponent,
    FeedComponent,
    HomeComponent,
    ObjectCardComponent,
    WidgetCardComponent,
    WorkspaceComponent,
    SearchSuggestComponent,
    UserBackgroundTaskListComponent,
    HeaderComponent,
    MainMenuComponent,
    DynamicFormComponent,
    AdvancedSearchComponent,
    NgToastComponent,
    SidebarComponent,
    // Reused by the sysadmin Use Case Template editor's Form-preview tab
    // (proposal §8/T5) so the author sees the wizard's exact inputs rendering.
    UseCaseInputsStepComponent,
  ],
})
export class CoreModule {}
